import React from 'react';
import { TileLayer } from 'react-leaflet';
import { LeafletBaseLayer, LeafletLabelsState } from './LeafletBaseLayerToggle';

interface Props {
    activeBaseLayer: LeafletBaseLayer;
    labelsByLayer: LeafletLabelsState;
}

function LeafletBaseLayers({ activeBaseLayer, labelsByLayer }: Props) {
    return (
        <>
            <TileLayer
                key={`base-${activeBaseLayer}`}
                url={
                    activeBaseLayer === 'map'
                        ? 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png?key=cb1_2bvx_1_037cb78532d08f42304c9da7'
                        : 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                }
            />
            {activeBaseLayer === 'map' && labelsByLayer.map && (
                <TileLayer
                    key="labels-map"
                    url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png?key=cb1_2bvx_1_037cb78532d08f42304c9da7"
                    pane="overlayPane"
                />
            )}
            {activeBaseLayer === 'satellite' && labelsByLayer.satellite && (
                <TileLayer
                    key="labels-satellite"
                    url="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}"
                    pane="overlayPane"
                />
            )}
        </>
    );
}

export default React.memo(LeafletBaseLayers);
